import { AlertModal } from '@modusign/design-system';

interface MaxAttachmentAlertModalProps {
  count: number;
  onConfirm: () => void;
}

function MaxAttachmentAlertModal({ count, onConfirm }: MaxAttachmentAlertModalProps) {
  return (
    <AlertModal isOpen title="최대 개수 초과" variant="warning" onClose={onConfirm}>
      한 문서 안에서 이용할 수 있는(요청자 포함)
      <br />
      첨부파일 {count}개를 모두 이용하셨습니다.
    </AlertModal>
  );
}

export default MaxAttachmentAlertModal;
